import { cn } from '@/lib/utils';

function Kbd({ className, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'pointer-events-none inline-flex w-fit items-center justify-center gap-0.5 select-none',
        '[&_svg:not([class*=\'size-\'])]:size-3',
        // @genesys-start — editor keyboard hint styling
        'rounded border border-border/70 bg-muted p-1 font-mono text-0.5xs font-medium leading-none text-foreground tabular-nums',
        'shadow-[inset_0_1px_0_0_rgb(255_255_255/0.14),0_1px_2px_rgb(0_0_0/0.06)]',
        'dark:border-white/12 dark:shadow-[inset_0_1px_0_0_rgb(255_255_255/0.1),0_1px_3px_rgb(0_0_0/0.4)]',
        'in-data-[slot=tooltip-content]:border-border/45 in-data-[slot=tooltip-content]:bg-foreground/14 in-data-[slot=tooltip-content]:text-inherit in-data-[slot=tooltip-content]:shadow-none',
        // @genesys-end
        className
      )}
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="kbd-group"
      className={cn('inline-flex items-center gap-1', className)}
      {...props}
    />
  );
}

export { Kbd, KbdGroup };
